import React, {Component} from 'react';
import './Message.css';

class Message extends Component {

    render() {
        if(typeof this.props.messages !== 'undefined' && this.props.messages !== null && this.props.messages.length > 0) {
            var c = "alert alert-" + this.props.status;
            return <div className={c}>
                <ul>
                    {this.props.messages.map(function(item,index){
                        return <li key={index} dangerouslySetInnerHTML={{__html:item}} />
                    })}

                </ul>
            </div>
        }else{
            return null;
        }

    }
}

export default Message;


// WEBPACK FOOTER //
// ./src/Components/Elements/Message/Message.js